import img from '../../helpers/img';

export default {
  title: 'UpMo',
  tile: {
    grid: 'col-12 lap-3',
    bgImage: img('upmo/upmo-landing-v1.jpg')
  },
  hero: {
    bgImage: img('upmo/upmo-landing-v1.jpg'),
    bgPosition: 'top'
  },
  info: {
    client: 'Upwardly Mobile',
    timeline: 'Nov 2011 - Oct 2012',
    description: [
      'UpMo is a web app in the HR space, empowering employees to advance their careers at the companies they already work for.',
      'I contributed front end development and design.'
    ],
    tools: `
      PHP,
      JS,
      SASS,
      jQuery,
      Grunt,
      Photoshop,
      Illustrator
    `,
    buttons: []
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('upmo/upmo-landing-v1.jpg'),
      caption: 'UpMo Hero'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('upmo/upmo-landing-v2.jpg'),
      caption: 'UpMo Landing Page v2'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('upmo/upmo-dashboard.jpg'),
      caption: 'UpMo Dashboard'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/upmo.js